import { useEffect, useState } from 'react';
import { Input } from '../../common/Forms/Input/Input';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as schemas from '../../..//assets/schemas/schemas';
import { ActionButton } from '../../common/Buttons/Buttons';
import {
  capitalize,
  filterParams,
} from '../../..//assets/helpers/funciones';
import {
  idCodes,
  phoneCodes,
  civilStateOptions,
  genderOptions,
  affiliationTypeOptions,
  idEnums
} from '../../..//assets/helpers/options';
import { customerChangeHistoryHeader } from "../../..//assets/helpers/tables"
import { parsePhoneNumberWithError } from 'libphonenumber-js';

import { membershipService } from '../../..//services/membershipService';
import { notify } from '../../..//assets/helpers/toast';
import { OderCardHeader } from '../../views/AffiliationsDB/Order/OrderComponents';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner';
import { ChangeCustomerModal, ClientChangeHistoryModal } from "../../common/Modals/Modals"
import { papService } from '../../../services/papService';

export const PAPClientInfoCard = (props) => {
  const { label, membership, reloadMembership } = props;
  const [open, setOpen] = useState(true);
  const [isLoading, setIsloading] = useState(false);

  const [changeCustomerModal, setChangeCustomerModal] = useState({
    isOpen: false
  });
  const [customerHistoryModal, setCustomerHistoryModal] = useState({
    isOpen: false
  });


  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    watch
  } = useForm({
    resolver: yupResolver(schemas.PAPorderClientInfoForm()),
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    reset: reset2,
    watch: watch2,
    control: control2,
  } = useForm({
    resolver: yupResolver(schemas.changeCustomerModal()),
  });

  const changeCustomer = handleSubmit2(async (data) => {
    let dataToPost = { ...data };

    dataToPost.membershipId = membership?._id;

    if (data.phone) {
      const parsedPhone = parsePhoneNumberWithError(data.phone);
      dataToPost.phonePrefix = "+" + parsedPhone.countryCallingCode;
      dataToPost.phoneNumber = parsedPhone.nationalNumber;
    }

    if (data.optionalPhone) {
      const parsedOptionalPhone = parsePhoneNumberWithError(data.optionalPhone);
      dataToPost.optionalPhonePrefix = "+" + parsedOptionalPhone.countryCallingCode;
      dataToPost.optionalPhoneNumber = parsedOptionalPhone.nationalNumber;
    }


    delete dataToPost?.countryCode;
    delete dataToPost?.phone;

    delete dataToPost?.optionalPhone;

    dataToPost = filterParams(dataToPost);

    if (!isLoading) {
      setIsloading(true);
      membershipService
        .changeCustomer(dataToPost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Cambio de cliente`, 'success');
            reloadMembership();
            setIsloading(false);
            handleChangeCustomerModal()
            window.location.reload()
          } else {
            notify(`${response.message}`, 'error');
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });



  const editCustomer = handleSubmit(async (data) => {
    let dataToPost = { ...data };


    if (data.phone) {
      const parsedPhone = parsePhoneNumberWithError(data.phone);
      dataToPost.phonePrefix = "+" + parsedPhone.countryCallingCode;
      dataToPost.phoneNumber = parsedPhone.nationalNumber;
    }

    // No birthday for J, R, G identifications
    if ([idEnums?.J, idEnums?.R, idEnums?.G].includes(watch('identificationType'))) {
      delete data.birthday
    }

    delete dataToPost?.countryCode;
    delete dataToPost?.phone;

    delete dataToPost?.optionalPhone;


    // dataToPost = filterParams(dataToPost);

    if (!isLoading) {
      setIsloading(true);
      papService
        .updatePAPClient(dataToPost, membership?.papClient?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Datos actualizados`, 'success');
            reloadMembership();
            setIsloading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const handleChangeCustomerModal = () => {
    setChangeCustomerModal((prevState) => {
      return {
        ...prevState,
        isOpen: !changeCustomerModal?.isOpen,
      };
    });
  }


  const handleVehicleHistoryModal = () => {
    setCustomerHistoryModal((prevState) => {
      return {
        ...prevState,
        isOpen: !customerHistoryModal?.isOpen,
      };
    });
  }




  const preloadForm = () => {
    setValue('firstName', capitalize(membership?.papClient?.firstName));
    setValue('lastName', capitalize(membership?.papClient?.lastName));
    setValue('identificationType', membership?.papClient?.identificationType);
    setValue(
      'identification',
      capitalize(membership?.papClient?.identification)
    );
    setValue('phone', membership?.papClient?.phonePrefix + membership?.papClient?.phoneNumber);
    setValue('email', membership?.papClient?.email?.toLowerCase());
  };



  useEffect(() => {
    preloadForm();
  }, [open]);

  return (
    <>
      <ChangeCustomerModal
        modal={changeCustomerModal}
        handleModal={handleChangeCustomerModal}
        // getFleets={getFleets}
        register={register2}
        errors={errors2}
        action={changeCustomer}
        reset={reset2}
        watch={watch2}
        control={control2}
        // onChange={{ getRoles: getRoles }}
        options={{
          genderOptions: genderOptions,
          phoneCodes: phoneCodes,
          civilStateOptions: civilStateOptions,
          idCodes: idCodes,
          affiliationTypeOptions: affiliationTypeOptions,
        }}
      />
      <ClientChangeHistoryModal
        modal={customerHistoryModal}
        handleModal={handleVehicleHistoryModal}
        header={customerChangeHistoryHeader}
        data={membership?.customerHistory}
      />

      <LoadSpinner show={isLoading} />
      <div className="order-card">
        <OderCardHeader open={open} setOpen={setOpen} label={label} />

        {open && (
          <>
            <div className="change-flow-button-container">
            </div>
            <br />
            <div className="buttons-container">
              <h6 style={{ margin: '6px 12px 12px 0px' }}>DATOS DEL CLIENTE</h6>
              <ActionButton label={'Guardar'} action={editCustomer} />
            </div>
            <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
            <div style={{ width: '100%' }} className="row">
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Nombre *'}
                type={'text'}
                name={'firstName'}
                register={register}
                placeholder={''}
                errors={errors?.firstName?.message}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Apellido *'}
                type={'text'}
                name={'lastName'}
                register={register}
                placeholder={''}
                errors={errors?.lastName?.message}
              />
              <Input
                bootstrap={'col-4 col-sm-1 col-md-1'}
                label={'C.I / RIF*'}
                type={'select'}
                name={'identificationType'}
                register={register}
                placeholder={''}
                options={idCodes}
                errors={errors?.identificationType?.message}
              />
              {
                [idEnums?.J, idEnums?.E, idEnums?.P]?.includes(watch('identificationType')) &&
                <Input
                  bootstrap={'col-8 col-sm-3 col-md-3'}
                  label={'del cliente*'}
                  type={'text'}
                  name={'identification'}
                  register={register}
                  placeholder={''}
                  errors={errors?.identification?.message}
                />
              }
              {
                ![idEnums?.J, idEnums?.E, idEnums?.P]?.includes(watch('identificationType')) &&
                <Input
                  bootstrap={'col-8 col-sm-3 col-md-3'}
                  label={'del cliente*'}
                  type={'number'}
                  name={'identification'}
                  register={register}
                  placeholder={''}
                  errors={errors?.identification?.message}
                />
              }
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Correo *'}
                type={'text'}
                name={'email'}
                register={register}
                placeholder={''}
                errors={errors?.email?.message}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Teléfono *'}
                type={'phone'}
                control={control}
                name={'phone'}
                register={register}
                placeholder={''}
                options={phoneCodes}
                errors={errors?.phone?.message}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};
